import { render, staticRenderFns } from "./ProductsProduct.vue?vue&type=template&id=62fc515a&scoped=true&"
import script from "./ProductsProduct.vue?vue&type=script&lang=js&"
export * from "./ProductsProduct.vue?vue&type=script&lang=js&"
import style0 from "./ProductsProduct.vue?vue&type=style&index=0&id=62fc515a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc515a",
  null
  
)

export default component.exports